{% block moorl_entity_grid_card %}
    <mt-card
        class="moorl-entity-grid-v2"
        :title="cardTitle"
    >
        <template
            v-for="(_, name) in $slots"
            v-slot:[name]="slotData"
        >
            <slot
                :name="name"
                v-bind="slotData"
            />
        </template>
        <moorl-entity-grid-v2
            :key="$attrs.entity"
            v-bind="$attrs"
        >
            <template
                v-for="(_, name) in $slots"
                v-slot:[name]="slotData"
            >
                <slot
                    :name="name"
                    v-bind="slotData"
                />
            </template>
        </moorl-entity-grid-v2>
    </mt-card>
{% endblock %}